import Vue from 'vue'

const mutations = {

  /**
   * @param state
   * @param roles
   */
  SET_ROLELIST (state, roles) {
    if (state.role_list.length > 0) state.role_list.length = []
    for (let index = 0; index < roles.length; index++) {
      state.role_list.push(roles[index])
    }
  },

  ADD_ROLE (state, role) {
    state.role_list.push(role)
  },

  SET_ROLES_SELECTED_LEFT (state, roles) {
    if (state.roles_selected_left.length > 0) state.roles_selected_left = []
    for (let index = 0; index < roles.length; index++) {
      state.roles_selected_left.push(roles[index])
    }
  },

  SET_ROLES_SELECTED_RIGHT (state, roles) {
    if (state.roles_selected_right.length > 0) state.roles_selected_right = []
    for (let index = 0; index < roles.length; index++) {
      state.roles_selected_right.push(roles[index])
    }
  },

  UPDATE_ROLE (state, role) {
    console.log('FIXME UPDATE_ROLE')
  },

  ADD_ROLE_TO_ROLELIST (state, roleData) {
    state.role_list.push(roleData)
  },

  UPDATE_ROLE_IN_ROLELIST (state, roleData) {
    let updatedRoleIndex = state.role_list.findIndex(oldRole => oldRole.id === roleData.id)
    if (updatedRoleIndex !== -1) {
      Vue.set(state.role_list, updatedRoleIndex, roleData)
    }
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/role/role.mutations.js
// module id = null
// module chunks = 